import { Chat } from './Chat';
import { useChatWithDocumentReview } from './useChatWithDocumentReview';
import { useUserName } from './useUserName';
export function ReviewChat({ feedback }) {
    const userName = useUserName();
    const { messages, actions, chat } = useChatWithDocumentReview(feedback.feedback.id);
    const send = (userMessage) => chat(userMessage);
    return (<Chat send={send} messages={messages} actions={actions} userName={userName} feedback={feedback}/>);
}
